import * as UI         from '../ui';
import { isPuppeteer } from './env';
import Transloadit     from '@uppy/transloadit';
import Uppy            from '@uppy/core';
import uuidv4          from 'uuid/v4';
import XHRUpload       from '@uppy/xhr-upload';

const authKey = 'dc15338084b911e3a9b35185d1910e1b';

export function uploadAvatar({ blob, mimeType }) {
  const templateID = '271ceff012b111e98c8def0d697b98a9';
  const path       = `/avatars/${uuidv4()}.png`;
  const url        = `https://attachment.broadly.com${path}`;

  return async function(dispatch) {
    await upload({
      dispatch,
      data: blob,
      mimeType,
      path,
      templateID
    });

    return url;
  };
}

export function uploadThankYouImage({ blob, mimeType }) {
  const templateID = 'eec5df002e2a11e9979a0d7592984e25';
  const path       = `/messaging/sms/${uuidv4()}.png`;
  const url        = `https://attachment.broadly.com${path}`;

  return async function(dispatch) {
    await upload({
      dispatch,
      data: blob,
      mimeType,
      path,
      templateID
    });

    return url;
  };

}

function upload({ dispatch, data, mimeType, path, templateID }) {
  const uppy = getUppy({ path, templateID });
  return new Promise((resolve, reject) => {
    uppy.run()
      .on('upload', () => dispatch(UI.progressStart()))
      .on('complete', function(result) {
        dispatch(UI.progressEnd());
        if (result.successful.length)
          resolve();
        else
          reject(Error('There was an error uploading the file'));
      })
      .on('error', reject);

    uppy.addFile({ type: mimeType, data });
    uppy.upload();
  });
}

// The Transloadit backend uses websockets to upload and poll.
// We can't test websockets (yet).
// When running tests (puppeteer mode), let's use XHRUpload to upload, so we can test it.
function getUppy({ path, templateID }) {
  if (isPuppeteer()) {
    return Uppy({ autoProceed: false })
      .use(XHRUpload, {
        endpoint: 'https://mock.transloadit.com/upload',
        formData: false
      });
  } else  {
    return Uppy({ autoProceed: false })
      .use(Transloadit, {
        /* eslint-disable camelcase */
        params: {
          auth: {
            key: authKey
          },
          template_id: templateID,
          steps:       {
            store: {
              path
            }
          }
        },
        /* eslint-enable camelcase */
        waitForEncoding: true
      });
  }
}
